import { render } from "./timereview.vue?vue&type=template&id=dacc4698"
import script from "./timereview.vue?vue&type=script&lang=js"
export * from "./timereview.vue?vue&type=script&lang=js"

import "./timereview.vue?vue&type=style&index=0&id=dacc4698&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__